import { c as _c } from "react/compiler-runtime";
import { type DividerProps } from './types';
import { StyledDividerContainer, StyledLine, StyledTextContainer, StyledDividerVerticalContainer, StyledVerticalLine } from './styles';
import { DIVIDER_CLASS_NAME, DIVIDER_VERTICAL_CLASS_NAME } from './classNames';
const Divider = t0 => {
  const $ = _c(15);
  const {
    text,
    textVariant: t1,
    vertical: t2,
    height,
    textAlignment: t3,
    disablePadding: t4
  } = t0;
  const textVariant = t1 === undefined ? "h5" : t1;
  const vertical = t2 === undefined ? false : t2;
  const textAlignment = t3 === undefined ? "left" : t3;
  const disablePadding = t4 === undefined ? false : t4;
  const renderTextElement = !(text === "" || text === undefined);
  if (vertical) {
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <StyledVerticalLine />;
      $[0] = t5;
    } else {
      t5 = $[0];
    }
    let t6;
    if ($[1] !== height) {
      t6 = <StyledDividerVerticalContainer className={DIVIDER_VERTICAL_CLASS_NAME} height={height}>{t5}</StyledDividerVerticalContainer>;
      $[1] = height;
      $[2] = t6;
    } else {
      t6 = $[2];
    }
    return t6;
  }
  let t5;
  if ($[3] !== textAlignment) {
    t5 = textAlignment === "center" && <StyledLine />;
    $[3] = textAlignment;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== renderTextElement || $[6] !== text || $[7] !== textVariant) {
    t6 = renderTextElement && <StyledTextContainer variant={textVariant}>{text}</StyledTextContainer>;
    $[5] = renderTextElement;
    $[6] = text;
    $[7] = textVariant;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <StyledLine />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== disablePadding || $[11] !== renderTextElement || $[12] !== t5 || $[13] !== t6) {
    t8 = <StyledDividerContainer className={DIVIDER_CLASS_NAME} $hasTextElement={renderTextElement} $disablePadding={disablePadding}>{t5}{t6}{t7}</StyledDividerContainer>;
    $[10] = disablePadding;
    $[11] = renderTextElement;
    $[12] = t5;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default Divider;
export { Divider };